export default function (source) {
  const fields = [...source]
  fields.sort((a, b) => a.field.localeCompare(b.field)).sort((a, b) => b.type.localeCompare(a.type))

  fields.map(item => {
    if (item.field.indexOf('password') !== -1) {
      item.type = 'password'
    }

    if (item.label.toLowerCase().indexOf('password') !== -1) {
      item.type = 'password'
    }

    if (item.field.indexOf('phone') !== -1) {
      item.type = 'tel'
    }

    return item
  })

  return fields
}
